var app = angular.module("leonardo");

var ChangeStatusTemplateDialog = function($scope, TemplateService) {

  $scope.status = $scope.ngDialogData.status;
  $scope.filters = $scope.ngDialogData.filters;

  $scope.title = $scope.status == TemplateService.STATUS_UNPUBLISHED ? 'disable' : 'enable';
};

app.controller('ChangeStatusTemplateDialog', ['$scope', 'TemplateService', ChangeStatusTemplateDialog]);
